import { useStore } from '@/store/useStore';
import { RefObject, useEffect, useState } from 'react';

export const useShakePanel = (panelRef: RefObject<HTMLDivElement | null>) => {
    const racerPanelShakeTick = useStore((state) => state.racerPanelShakeTick);
    const [shaking, setShaking] = useState(false);

    useEffect(() => {
        if (racerPanelShakeTick === 0) return;
        setShaking(true);
        const panel = panelRef.current;
        const onEnd = () => setShaking(false);
        panel?.addEventListener('animationend', onEnd, { once: true });

        return () => panel?.removeEventListener('animationend', onEnd);
    }, [racerPanelShakeTick]);

    return shaking;
};
